// extracted by mini-css-extract-plugin
module.exports =  {"tableWrapper":"kKvL03xNwUz_hE1RGpYe","truncate":"Xo9cqGEroboREd8MDcli"};